<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">员工</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>员工详情</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create @refresh="getStaffAndKpiList"></create>
        <!-- <get-staff-amount @refresh="getStaffAndKpiList"></get-staff-amount> -->
      </div>
      <list @refresh="getStaffAndKpiList"></list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import Create from './components/create';
import List from './components/list';
import baseConfig from './components/baseConfig';
import SetPercent from './components/setpercent';
import SearchAmount from './components/searchAmount';
import GetStaffAmount from './components/getStaffAmount';

export default {
  name: 'staff',
  data() {
    return {
      options: [
        {
          value: '1',
          label: '邀请额度'
        },
        {
          value: '2',
          label: 'USDT额度'
        },
        {
          value: '3',
          label: 'FBS额度'
        },
        {
          value: '4',
          label: '全部额度'
        }
      ],
      updated: ''
    };
  },
  components: {
    List,
    Create,
    GetStaffAmount
    // baseConfig,
    // SetPercent,
    // SearchAmount
  },
  computed: {
    ...mapState('staff', ['pagination'])
  },
  methods: {
    ...mapActions('staff', ['getList', 'getCoinTypeList', 'freshData']),
    getStaffAndKpiList(data = {}) {
      this.getList();
    },
    update() {
      this.freshData({ target: this.updated }).then(() => {
        this.updated = '';
      });
    }
  },
  created() {
    this.getStaffAndKpiList();
  }
};
</script>
<style lang="less" scoped>
.change {
  ::v-deep .el-button {
    margin-left: 20px;
  }
}
</style>
